import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {useDispatch, useSelector} from "react-redux";
import {changeContract} from "../contractSlice";

export default function ConfigurationsTabs() {
    const [configTabValue, setConfigTabValue] = React.useState(1);
    const selectorContractAPI = useSelector((state) => state.contractSlc.value.module);
    const dispatchData = useDispatch();

    const handleChange = (event, newValue) => {
        setConfigTabValue(newValue);

        // if ((newValue === 0) && (selectorContractAPI === 'ResPre' || selectorContractAPI === 'ResPost' || selectorContractAPI === 'ResSystem')){
            if ((newValue === 0) && (selectorContractAPI === 'Residuals' )){
            dispatchData(changeContract({residualsTabsIndex: 0, contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                residualsTabsVisible: true, module: 'Residuals',contractGridAPI: "CBA"}));
        }
        // if ((newValue === 0) && (selectorContractAPI === 'PartsPre' || selectorContractAPI === 'PartsPost' || selectorContractAPI === 'PartsSystem')){
        if ((newValue === 0) && (selectorContractAPI === 'Participations' )){
            dispatchData(changeContract({participationsTabsIndex: 0, contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                residualsTabsVisible: false, participationsTabsVisible: true,
            module: 'Participations',contractGridAPI: "PartsStandards"}));
        }

        if ((newValue === 0) && (selectorContractAPI === 'Royalties')) {
            dispatchData(changeContract({contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                residualsTabsVisible: false, participationsTabsVisible: true,
            module: 'Royalties',contractGridAPI: "RoyalStandards"}));
        }
        
        if (newValue === 1 && selectorContractAPI === 'Residuals') {
            dispatchData(changeContract({contractGridAPI: "ResPre"}));
        }
        if (newValue === 1 && selectorContractAPI === 'Participations') {
            dispatchData(changeContract({contractGridAPI: "PartsPre"}));
        }
        if (newValue === 1 && selectorContractAPI === 'Royalties') {
            dispatchData(changeContract({contractGridAPI: "RoyalPre"}));
        }
        if (newValue === 2 && selectorContractAPI === 'Residuals') {
            dispatchData(changeContract({contractGridAPI: "ResPost"}));
        }
        if (newValue === 2 && selectorContractAPI === 'Participations') {
            dispatchData(changeContract({contractGridAPI: "PartsPost"}));
        }
        if (newValue === 2 && selectorContractAPI === 'Royalties') {
            dispatchData(changeContract({contractGridAPI: "RoyalPost"}));
        }
        if (newValue === 3 && selectorContractAPI === 'Residuals') {
            dispatchData(changeContract({contractGridAPI: "ResSystem"}));
        }
        if (newValue === 3 && selectorContractAPI === 'Participations') {
            dispatchData(changeContract({contractGridAPI: "PartsSystem"}));
        }
        if (newValue === 3 && selectorContractAPI === 'Royalties') {
            dispatchData(changeContract({contractGridAPI: "RoyalSystem"}));
        }
    }


    return (
        <Box sx={{pt: 2, width: '100%', height: 75, bgcolor: 'background.paper' }}>
            <Tabs value={configTabValue} defaultValue={"Pre-Conditions"}
                  onChange={handleChange} centered>
                <Tab label="BACK"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                <Tab label="Pre-Conditions"
                     title="Configurations and methods added to contract models to aid in selecting and navigating master contracts"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}/>
                <Tab label="Post-Conditions"
                     title="Configurations and methods added to contract models to assist in the administration of individual contracts"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                <Tab label="System Configurations"
                     title="Global Configurations maintained in the system"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
            </Tabs>
        </Box>
    );
}
